
<!-- 精品项目 -->
<template>
  <div>
    <!-- 使用table布局-头部条件查询 -->
    <table>
      <tr>
        <!-- 条件-付费类型 -->
        <td style="text-align: right; width: 600px">
          <el-select
            style="width: 50%"
            v-model="form.priceType"
            clearable
            placeholder="费用类型"
          >
            <el-option
              v-for="item in priceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </td>
        <td style="width: 300px; text-align: center">
          <!-- 条件-项目类型下拉选择 -->
          <el-select
            style="width: 100%"
            v-model="form.projectType"
            clearable
            placeholder="项目类型"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </td>
        <td style="width: 300px">
          <el-input
            v-model="form.title"
            placeholder="请输入项目名称"
          ></el-input>
        </td>
        <td>
          <el-button
            icon="el-icon-search"
            circle
            @click="findProject(1, 12)"
          ></el-button>
        </td>
      </tr>
    </table>

    <!-- 中间内容+底部导航 -->
    <div>
      <table>
        <!-- 第一行 -->
        <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
          <td></td>
          <td
            style="width: 300px"
            v-for="(item, itemIndex) in row"
            :key="itemIndex"
            @click="projectDetail(item.projectId)"
          >
            <el-card
              shadow="hover"
              :body-style="{ padding: '0px' }"
              
            >
              <!-- 图片 -->
              <img :src="item.coverUrl" class="image" />
              <!-- 内容标题 -->
              <div style="padding: 14px">
                <div class="container">
                  <span class="ellipsis">{{ item.title }}</span>
                </div>

                <div class="bottom clearfix">
                  <time class="time">{{ item.createtime }}</time>
                </div>
              </div>
            </el-card>
          </td>
          <td></td>
        </tr>

        <!-- 底部导航 -->
        <tr>
          <td></td>
          <td></td>
          <td colspan="2" style="text-align: center">
            <!-- 底部页脚 -->
            <div class="block">
              <!-- <span class="demonstration">大于 7 页时的效果</span> -->
              <el-pagination
                layout="prev, pager, next"
                :total="res.data.total"
                :page-size="res.data.pageSize"
                :current-page="res.currentPage"
                @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
          </td>
          <td></td>
          <td></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
// 导入接口api
import { findProject } from "@/api/appProject/delicacyProject.js";
export default {
  // 定义数据
  data() {
    return {
      // 查询-请求对象
      form: {},
      // 响应数据对象-list集合中数据
      resList: [],
      // 项目的全部数据
      res: {},

      // 条件下拉框中的值-项目类型
      options: [
        {
          value: "1",
          label: "前端项目",
        },
        {
          value: "2",
          label: "java后端项目",
        },
      ],
      // 条件-费用类型
      priceType: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: "public",
          label: "免费",
        },
        {
          value: "pointsRequired",
          label: "付费",
        },
      ],
    };
  },

  computed: {
    // 将列表按每 4 个分成一行
    rows() {
      const itemsPerRow = 4;
      let result = [];
      for (let i = 0; i < this.resList.length; i += itemsPerRow) {
        result.push(this.resList.slice(i, i + itemsPerRow));
      }
      return result;
    },
  },

  // 一进入项目立即执行
  created() {
    // 调用项目查询接口
    this.findProject(1, 12);
  },

  // 公共方法
  methods: {
    // 查询所有项目内容,pageNumber:当前页，pageSize：每页大小
    async findProject(pageNumber, pageSize) {
      // 设置当前页，和每页条数
      this.form.pageNumber = pageNumber;
      this.form.pageSize = pageSize;
      const res = await findProject(this.form);

      // 判断查询出结果的状态
      if (res.status === "200") {
        // this.$message({
        //   message: res.message,
        //   type: "success",
        // });

        this.res = res;
        this.res.currentPage = pageNumber;
        // 进行赋值-list中的值
        this.resList = res.data.list;
      }
    },

    // 点击页数执行方法
    handlePageChange(page) {
      // 调用查询方法
      this.findProject(page, 12);
    },

    // 点击精品项目-跳转详情
    projectDetail(projectId){
      console.log("进入详情跳转方法，获取的项目id:"+projectId);
      // 使用查询参数的方式跳转
      this.$router.push({ path: `/delicacyProject/delicacyProjectDetail/${projectId}` });

    }

  },
};
</script>

<style scoped>
/* table标签布局样式 */
table {
  width: 100%;
  margin: 20px; /* 设置表格的外边距 */
}
th,
td {
  /* border: 2px solid #4caf50; 定义表头和单元格的边框颜色和宽度 */
  padding: 20px; /* 设置单元格内边距 */
}

/* 中间内容-样式 */
.time {
  font-size: 13px;
  color: #999;
}

.image {
  width: 100%;
  height: 175px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

/* 中间内容其中的一个 - 设置字体样式 */
.container {
  width: 300px; /* 设置容器的宽度 */
  overflow: hidden; /* 隐藏超出部分 */
  display: -webkit-box; /* 使用弹性盒子模型 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  -webkit-line-clamp: 3; /* 设置行数为3 */
}

.ellipsis {
  display: block; /* 使 span 作为块级元素 */
}
</style>